import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { eraseLayer } from "../../../../redux/slices/layers";

export default function RemoveLayerModal(props) {
  const dispatch = useDispatch();
  return (
    <Dialog
      open={props.removeLayerModal.show}
      onClose={() => props.setRemoveLayerModal({ show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Are you sure you want to delete this layer?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          After confirmation, the layer will be erased definitevely from the
          style. This step can not be rolled back.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>
            props.setRemoveLayerModal({ show: false, layer: null })
          }
          autoFocus
        >
          Cancel
        </Button>
        <Button
          color="error"
          onClick={() => {
            dispatch(eraseLayer(props.removeLayerModal.layer.id));
            props.setRemoveLayerModal({ show: false, layer: null });
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
